









































































import { requiredRule } from "@/lib/rules/requiredRule";
import { IReport } from "@/models/report.entity";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IDamage } from "@/models/damage.entity";
import { DamageTypeEnum } from "@/store/enum/damage-type.enum";
import { CoverageTypeEnum } from "@/store/enum/coverage-type.enum";
import CustomFieldBoolean from "@/components/report/CustomFieldBoolean.vue";
import { TotalLossType } from "@/lib/enum/total-loss-type.enum";

@Component({
  components: { CustomFieldBoolean },
  filters: {}
})
export default class DamageForm extends Vue {
  DamageTypeEnum = DamageTypeEnum;
  CoverageTypeEnum = CoverageTypeEnum;
  TotalLossType = TotalLossType;

  @Prop()
  value!: IDamage;

  @Prop()
  report?: IReport;

  get requiredRule() {
    return [requiredRule()];
  }

  get partner() {
    return PartnerModule.partner;
  }

  get damageTypeItems() {
    return (this.partner.settings?.damageTypes ?? Object.values(DamageTypeEnum)).map(value => ({
      value,
      text: this.$t(`enums.DamageTypeEnum.${value}`)
    }));
  }
}
